import { MAX_EVENT_FILTER_IDS } from './max-event-filter-ids.js';

export function capEventFilterIds<Id extends number | string>(ids: Id[]): Id[] {
  return ids.slice(0, MAX_EVENT_FILTER_IDS);
}
